import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { AuthCheckDtoRole } from '@/api-client/api';

export const useUserState = create<{
    role: AuthCheckDtoRole | null,
    setRole: (role: AuthCheckDtoRole | null) => void;
    userId: string | null;
    setUserId: (userId: string | null) => void;
}>()(
    persist(
        (set) => ({
            role: null,
            userId: null,
            setRole: (role: AuthCheckDtoRole | null) => set({ role }),
            setUserId: (userId: string | null) => set({ userId }),
        }),
        {
            name: 'user',
            storage: createJSONStorage(() => localStorage),
        },
    ),
)